import { useEffect, useState } from 'react';

import { LoadingIndicator } from './components/LoadingIndicator';
import { PageIdContextProvider } from './providers/page-id-context';
import { CheckPageId } from './routes/route-before';

function App() {
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoadingIndicator(true);
    }, 500);

    return () => clearTimeout(timer); // 컴포넌트 언마운트 시 타이머 정리
  }, []);

  return (
    <>
      <PageIdContextProvider>
        <CheckPageId>{showLoadingIndicator && <LoadingIndicator />}</CheckPageId>
      </PageIdContextProvider>
    </>
  );
}

export default App;
